// library imports
import React, { useImperativeHandle, forwardRef, useRef } from "react";

// styles imports
import './LayoutElement.scss';

const PageContent = forwardRef((props, ref) => {
    const localRef = useRef();
    return (
        <div id={props.pageId} className="page-content" ref={ref}>
            {props.children}
        </div>
    );
});

export default PageContent;